import React from 'react';
import { Link } from 'react-router-dom';
import AuthLayout from './AuthLayout';

const PasswordSuccess = () => {
  return (
    <AuthLayout>
      <div className="w-full max-w-md text-center">
        <div className="mx-auto w-24 h-24 mb-8 relative">
          <div className="absolute inset-0 bg-blue-100 rounded-full opacity-20"></div>
          <div className="absolute inset-2 bg-blue-100 rounded-full opacity-40"></div>
          <div className="absolute inset-4 bg-blue-100 rounded-full flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <div className="absolute -top-1 -right-1 w-3 h-3 bg-blue-100 rounded-full"></div>
          <div className="absolute top-2 -right-3 w-2 h-2 bg-blue-100 rounded-full"></div>
          <div className="absolute -bottom-1 -left-1 w-2 h-2 bg-blue-100 rounded-full"></div>
        </div>

        <h2 className="text-3xl font-bold mb-4">All set well done!</h2>
        <p className="text-gray-600 mb-8">Try to login for next step.</p>

        <Link 
          to="/login"
          className="w-full inline-block bg-blue-500 text-white py-3 rounded-lg hover:bg-blue-600 transition duration-200"
        >
          Back to login
        </Link>
      </div>
    </AuthLayout>
  );
};

export default PasswordSuccess; 